import React from "react"
import { GoogleMap, IMapApi } from "./googleMap"
//export { IMapApi, IMarker, Marker, IMarkerSymbol } from "./googleMap"

export interface MapProps extends React.Props<Map> {
    defaults?: { centerLat: number, centerLng: number, zoom: number };
    style?: React.CSSProperties;
    className?: string;
}

export class Map extends React.Component<MapProps> {
    div: HTMLDivElement;
    Api: IMapApi;

    constructor(props: MapProps) {
        super(props);
    }

    componentDidMount() {
        let { centerLat, centerLng, zoom }: { centerLat: number, centerLng: number, zoom: number } = this.props.defaults || { centerLat: 43, centerLng: 12, zoom: 14 };
        this.Api = GoogleMap.init(this.div, centerLat, centerLng, zoom);
    }

    refresh() {
        this.Api.redraw();
    }

    render() {
        return (
            <div className={this.props.className || "mapContainer"} style={this.props.style}>
                <div className="map" ref={div => this.div = div!} />
            </div>);
    }
}